import { render, staticRenderFns } from "./NsSlottedDropdown.vue?vue&type=template&id=37b6d276&scoped=true&"
import script from "./NsSlottedDropdown.vue?vue&type=script&lang=js&"
export * from "./NsSlottedDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NsSlottedDropdown.vue?vue&type=style&index=0&id=37b6d276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6d276",
  null
  
)

export default component.exports